module.exports = __webpack_public_path__ + "static/img/xf1.099c283.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/xinqingBrand/assets/xf1.png
// module id = Fi+a
// module chunks = 0